import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18TextstyleG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
      fillRule: "evenodd",
      d: "M15.738 11.15v.683c0 1.224-1.054 2.183-2.4 2.183-1.037 0-1.708-.527-1.708-1.342 0-.806.66-1.31 1.81-1.384zm.592-4.09c-.59-.505-1.432-.77-2.434-.77-1.414 0-2.694.637-3.185 1.584-.115.209-.177.42-.177.611 0 .397.273.674.664.674.287 0 .484-.115.62-.362.469-.832 1.08-1.187 2.045-1.187 1.174 0 1.875.623 1.875 1.666v.703l-2.467.14c-2.01.117-3.161 1.048-3.161 2.555 0 1.568 1.167 2.62 2.904 2.62 1.175 0 2.271-.638 2.799-1.63v.875c0 .445.294.756.714.756.416 0 .707-.31.707-.756V9.135c0-.853-.312-1.572-.904-2.076zm-13.3 3.359 1.907-5.431h.016l1.907 5.43H3.03zm6.767 3.77L5.925 3.731C5.738 3.232 5.432 3 4.96 3c-.497 0-.816.235-1.004.74L.093 14.19a1.3 1.3 0 0 0-.093.424c0 .395.326.68.773.68.383 0 .608-.175.755-.59L2.58 11.74H7.3l1.06 2.965c.147.414.373.59.756.59.447 0 .773-.286.773-.681 0-.117-.03-.247-.093-.425z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18TextstyleG$1 = Svg18TextstyleG;

export { Svg18TextstyleG$1 as default };
